module.exports = __webpack_public_path__ + "img/sRickyTyco_350x350.a05a0e07.jpg";